// AUTO-GENERATED by scripts/import-page-videos.cjs — do not edit by hand.
// Titles come from YouTube's public oEmbed endpoint, so they are the real
// video titles. uploadDate/duration are unavailable there and are therefore
// omitted from the VideoObject markup rather than guessed.

export interface PageVideo {
  id: string;
  title: string;
  author?: string;
}

const pageVideos: Record<string, PageVideo[]> = {
  "/top-ayurvedic-centers-in-india/ayurmana-ayurveda-hospital-kerala-india": [
    {
      "id": "gR3t_yotVog",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Mrs Lynne letherparrow",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "YsSPR0nvuvw",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Ms Natasha Hladnik",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "g0jDddBhfOs",
      "title": "Mr Eliezer's Remarkable Recovery: Best Ayurvedic joint pain Treatment in Kerala, India",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "SYjjIADWXMk",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Ms Fabienne Marbacha",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "o3gjE6jQ7NY",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Ms Virginia",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "giwjMnPcK70",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Mrs Ekaterina From Russia",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "wfLwpOt3xF8",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Mrs Beverly From France",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "xg2nT59Vj_s",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Mrs Louiza Preka  From Greece",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "6nDO0U1feP8",
      "title": "Ayurmana Ayurvedic Treatment Testimonial |  Sasha Miklic From Slovenia",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "B1MTyTcW088",
      "title": "Ayurmana Ayurvedic Treatment Testimonial |  Mr Rolf Zimmerman from Germany",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "CgeLJx21qN4",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Alexandra Paul",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "9-ndvp6sdMs",
      "title": "Ayurmana Ayurvedic Treatment Testimonial | Heidi",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    },
    {
      "id": "YOiCvI6P8B0",
      "title": "Ayurmana Ayurvedic Treatment Testimonial - Janja Frank",
      "author": "Ayurmana Ayurvedic Hospital & Treatment Centre"
    }
  ],
  "/top-ayurvedic-centers-in-india/athreya-ayurvedic-center-kerala-india": [
    {
      "id": "uB1IzLhZhX4",
      "title": "A Life-Changing 21 Days | Cristina’s Honest Review of Athreya Ayurvedic Centre",
      "author": "Athreya Ayurvedic Centre"
    }
  ]
};

export default pageVideos;

export const videosForRoute = (pathname: string): PageVideo[] =>
  pageVideos[pathname.replace(/\/+$/, "") || "/"] ?? [];
